<template>
  <div class="landing-page">
    <LandingNav />
    <template v-for="block in visibleBlocks" :key="block._id">
      <component v-if="block.visible" :is="componentMap[block.type]" v-bind="block.data" />
    </template>
    <AppFooter />
    <GlobalAudioPlayer />
  </div>
</template>

<script setup>
const props = defineProps({
  blocks: { type: Array, required: true }
})

const { tenant } = useTenantTheme()

// Drop pricing blocks from the rendered stream when the tenant has no
// Stripe subscriptions configured — the plans component would render
// empty cards otherwise, since it pulls from tenant.stripe.plans.
const visibleBlocks = computed(() => {
  if (tenant.value?.subscriptionsEnabled) return props.blocks
  return props.blocks.filter(b => b.type !== 'pricing')
})

const componentMap = {
  hero: resolveComponent('LandingHero'),
  features: resolveComponent('LandingFeatures'),
  stats: resolveComponent('LandingStats'),
  cta: resolveComponent('LandingCTA'),
  pricing: resolveComponent('LandingPricing'),
  textImage: resolveComponent('LandingTextImageBlock'),
  releaseGrid: resolveComponent('LandingReleaseGridBlock'),
  richText: resolveComponent('LandingRichTextBlock'),
  spacer: resolveComponent('LandingSpacerBlock'),
}
</script>

<style>
.landing-page {
  background-color: var(--bg-color);
  color: var(--text-main);
  overflow-x: hidden;
  min-height: 100vh;   /* fallback */
  min-height: 100svh;  /* stable against iOS URL-bar collapse */
}
</style>
